export default __webpack_public_path__ + "static/media/ic_add_circle.1554def7.svg";